<template>
  <div class="review-manage-container">
    <check
      v-if="isHasCheckLimit"
      :id="id"
      :layout-id="layoutId"
      :is-show-report="isShowReport"
      :is-show-operate="isShowOperate"
      :system="String(system)"
    />
    <el-form
      v-if="isShowReviewOper"
      :model="reviewForm"
      ref="ruleForm"
    >
      <el-form-item
        label="审读意见："
        prop="suggestion"
      >
        <el-input
          v-model="reviewForm.suggestion"
          type="textarea"
          resize="none"
          maxlength="500"
        />
      </el-form-item>
      <el-form-item
        label="审读人："
        prop="auditor"
      >
        <el-input
          v-model="reviewForm.auditor"
          :disabled="true"
        />
      </el-form-item>
      <el-form-item class="el-form-item_btn">
        <el-button
          @click="operate(true)"
          v-show="showPassBtn"
          :disabled="!(currentItem && currentItem.id)"
        >
          通过
        </el-button>
        <el-button
          @click="operate(false)"
          v-show="showRebackBtn"
          :disabled="!(currentItem && currentItem.id)"
        >
          不通过
        </el-button>
      </el-form-item>
    </el-form>
    <el-table
      class="review-table"
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column label="审读操作记录">
        <el-table-column
          prop="index"
          width="32"
        />
        <el-table-column
          prop="operate"
          label="操作"
          width="62"
        />
        <el-table-column
          prop="auditor"
          label="操作人"
          width="70"
        >
          <template slot-scope="scope">
            <span :title="scope.row['auditor']">{{
              scope.row["auditor"]
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="reviewTime"
          label="操作时间"
          width="90"
        />
        <el-table-column
          prop="comment"
          label="意见"
        >
          <template slot-scope="scope">
            <span :title="scope.row['comment']">{{
              scope.row["comment"]
            }}</span>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { toTopAnimation } from '@common/util.js'
import check from './check.vue'
import APIS from '@apis/jlxk.js'
export default {
  name: 'ReviewManage',
  components: {
    check
  },
  props: {
    currentItem: {
      type: Object,
      default: () => {}
    },
    isShowReviewOper: {
      type: Boolean,
      default: true
    },
    isShowPassBtn: {
      type: Boolean,
      default: true
    },
    layoutId: {
      type: String,
      default: ''
    },
    isShowOperate: {
      type: Boolean,
      default: false
    },
    isShowReport: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      reviewForm: {
        suggestion: '',
        auditor: login_cookie['name']
      },
      tableData: [],
      typeArr: ['1', '4']
    }
  },
  computed: {
    id() {
      return this.currentItem && this.currentItem.id
    },
    system() {
      return (this.currentItem && this.currentItem.system) || 0
    },
    articeType() {
      return this.currentItem && this.currentItem.articletypeid
    },
    type() {
      return (
        this.articeType && this.typeArr.indexOf(String(this.articeType)) !== -1
      )
    },
    isHasCheckLimit() {
      return this.system === 1 || (this.system === 0 && this.type)
    },
    status() {
      return (this.currentItem && this.currentItem.status) || 4
    },
    // 互联网数据提交待审和退回的还可以通过
    showPassBtn() {
      let arr = ['4', '6']
      return (
        this.isShowPassBtn ||
        (arr.indexOf(String(this.status)) !== -1 && String(this.system) === '1')
      )
    },
    // 互联网数据退回稿件不展示退回
    showRebackBtn() {
      return !(String(this.system) === '1' && String(this.status) === '6')
    }
  },
  methods: {
    // 审核操作列表
    async getSpcialDetail(val) {
      let params = {
        id: val
      }
      let { status, data } = await APIS.postSpcialDetail({ data: params })
      if (status === 0 && data && data.flows && data.flows.length !== 0) {
        this.tableData = data.flows.map((item, index) => {
          return {
            index: index + 1,
            operate: item.operate,
            auditor: item.userName,
            reviewTime: item.operateTime.slice(5),
            comment: item.comment
          }
        })
        this.$nextTick(() => {
          toTopAnimation('.review-manage-container .el-table__body-wrapper')
        })
      } else {
        this.tableData = []
      }
    },
    initParams() {
      this.tableData = []
      if (this.isShowReviewOper) {
        this.$nextTick(() => {
          this.$refs.ruleForm.resetFields()
        })
      }
    },
    operate(isPass) {
      let params = {
        ids: this.currentItem && this.currentItem.id,
        toStatus: isPass ? '5' : '6',
        operate: isPass ? '通过' : '不通过',
        comment: this.reviewForm.suggestion
      }
      this.$emit('operate', params)
    }
  },
  watch: {
    currentItem: {
      handler(newVal) {
        this.initParams()
        if (newVal === 0 || !newVal) return false
        this.getSpcialDetail(newVal.id)
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.review-manage-container {
  padding: 0 25px;
  max-height: calc(100vh - 150px);
  overflow-y: auto;
  /deep/ .el-form {
    width: auto;
    margin-top: 5px;
    &-item {
      display: flex;
      margin: 20px 0 0 0;
      &__label {
        flex-shrink: 0;
        width: 67px;
        text-align: right;
        padding: 0;
        font-size: 13px;
        line-height: 31px;
        color: #333;
      }
      &__content {
        flex: 1;
        line-height: normal;
        .el-textarea__inner,
        .el-input__inner {
          background: #ffffff;
          border: 1px solid #b9b9b9;
          border-radius: 3px;
          font-size: 13px;
          font-family: "founder_youhei_508R";
        }
        .el-input.is-disabled .el-input__inner {
          color: #333;
        }
        .el-textarea__inner {
          height: 60px;
          padding: 5px 10px;
        }
      }
      &_btn {
        margin: 15px 0 0;
        text-align: center;
        .el-button {
          height: 28px;
          padding: 0 17px;
          background: #ffffff;
          border: 1px solid #d9e3f4;
          border-radius: 5px;
          color: #454647;
          + .el-button {
            margin-left: 10px;
          }
          &:hover {
            color: #3780f7;
            border-color: #4497ec;
          }
          &.is-disabled {
            color: #999;
            border-color: #ececec;
          }
        }
      }
    }
  }
  /deep/ .el-table.review-table {
    margin-top: 20px;
    border-color: #dcdcdc;
    border-width: 1px 0 0 1px;
    &::before {
      background-color: #dcdcdc;
    }
    .el-table__header {
      &-wrapper {
        th {
          text-align: center;
          padding: 0;
          font-size: 13px;
          height: 32px;
          font-weight: normal;
          background: #fff;
          color: #333;
          border-color: #dcdcdc;
          .cell{
            height:29px;
            line-height: 30px;
          }
        }
        .el-table_1_column_1 {
          background: #f5f5f5;
          color: #666;
        }
      }
    }
    .el-table__body {
      tr {
        display: flex;
        td {
          height: 32px;
          font-size: 12px;
          color: #454647;
          text-align: center;
          flex-shrink: 0;
          &:first-child {
            flex-basis: 32px;
          }
          &:nth-child(2) {
            flex-basis: 62px;
          }
          &:nth-child(3) {
            flex-basis: 70px;
          }
          &:nth-child(4) {
            flex-basis: 89px;
          }
          &:nth-child(5) {
            flex-basis: 146px;
          }
          .cell {
            line-height: 30px;
            padding: 0 5px;
            @extend .ellipsis;
          }
        }
      }
    }
  }
}
</style>
